import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_ProtocolDDXScore.scss';
import { Circle, Layer, Line, RegularPolygon, Stage, Text } from 'react-konva';
import { colors } from '@app/styles';
const globalLeftOffset = 4;
const barHeight = 38;
export const Component_ProtocolDDXScore = (props) => {
    if (props.width === 0)
        return _jsx(_Fragment, {});
    const variant = props.variant ?? 'full';
    const barWidth = props.width - 10;
    const cmo = props.protocol.careMapOutcomes?.[props.diseaseId];
    if (!cmo)
        return _jsx(_Fragment, {});
    return _jsxs(Stage, { width: props.width, height: barHeight, className: 'protocol-ddx-score', children: [_jsx(ProtocolDDXScore_Bar, { width: barWidth }), _jsx(ProtocolDDXScore_BarMarker, { bar: props.protocol.minConfidenceBar ?? 0, width: barWidth }), _jsx(ProtocolDDXScore_Score, { cmo: cmo, width: barWidth, variant: variant })] });
};
const ProtocolDDXScore_Bar = (props) => {
    return _jsxs(Layer, { children: [_jsx(Line, { points: [globalLeftOffset, barHeight / 2, props.width, barHeight / 2], stroke: colors.secondary['secondary-04'], strokeWidth: 4, lineCap: 'round', lineJoin: 'round' }), _jsx(Text, { text: '0', fontFamily: 'Archivo', x: globalLeftOffset, height: barHeight, verticalAlign: 'bottom', fill: colors.secondary['secondary-08'] }), _jsx(Text, { text: '100', fontFamily: 'Archivo', x: props.width - 10, height: barHeight, verticalAlign: 'bottom', fill: colors.secondary['secondary-08'] })] });
};
// Single threshold marker at the selector's confidence bar (min_confidence_bar,
// 0..1), stamped onto the protocol by the backend. Replaces the old LC/HC pair,
// which read the now-removed low/highConsiderationPercRecall fields.
const ProtocolDDXScore_BarMarker = (props) => {
    const x = props.bar * props.width + globalLeftOffset;
    return _jsx(Layer, { children: _jsx(Line, { points: [x, barHeight / 2 - 7, x, barHeight / 2 + 7], stroke: colors.secondary['secondary-08'], strokeWidth: 2, lineCap: 'round' }) });
};
const ProtocolDDXScore_Score = (props) => {
    // normalizedScore is a confidence in [0,1]; render it as an integer percentage
    // and position it at that fraction of the bar.
    const percent = Math.round(props.cmo.normalizedScore * 100);
    const x = props.cmo.normalizedScore * props.width + globalLeftOffset;
    if (props.variant === 'concise')
        return _jsx(ProtocolDDXScore_Score_Concise, { x: x, score: percent });
    return _jsx(ProtocolDDXScore_Score_Full, { x: x, score: percent });
};
const ProtocolDDXScore_Score_Concise = (props) => {
    return _jsx(Layer, { children: _jsx(RegularPolygon, { sides: 3, radius: 8, x: props.x, y: barHeight / 2, fill: colors.semantic['semantic_low-risk'] }) });
};
const ProtocolDDXScore_Score_Full = (props) => {
    return _jsxs(Layer, { children: [_jsx(Circle, { x: props.x, y: barHeight / 2, radius: 3, fill: colors.primary['primary-01'] }), _jsx(Text, { x: props.x - 10, width: 20, height: barHeight / 2, fontSize: 15, fontStyle: '600', fontFamily: 'Archivo', verticalAlign: 'top', align: 'center', text: `${props.score}`, fill: colors.primary['primary-02'] })] });
};
//# sourceMappingURL=Component_ProtocolDDXScore.js.map